export function Distinct(value, index, self) {
  return self.indexOf(value) === index;
}

export function SumNumber(array: number[]): number {
  return array
    .map((x) => {
      try {
        let parsed = parseFloat(x as any);
        if (!isNaN(parsed)) {
          return parsed;
        }
        return 0;
      } catch {
        return 0;
      }
    })
    .reduce((a, b) => a + b, 0);
}
